"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-bf21e72e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "baseInfoContent" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    props: {
        open: Boolean,
        title: String,
        baseInfo: Array,
        model: String,
    },
    emits: ['update:open'],
    setup(__props) {
        const baseInfoList = (0, vue_3.ref)([
            { name: '产品SN码', value: '--' },
            { name: '状态', value: '--' },
            { name: '一级物料编码', value: '--' },
            { name: '一级物料名称', value: '--' },
            { name: '规格型号', value: '--' },
            { name: '桩二维码', value: '--' },
            { name: '额定功率', value: '--' },
            { name: '枪数', value: '--' },
            { name: '产品组', value: '--' },
        ]);
        const showList = (0, vue_3.ref)([]);
        const props = __props;
        (0, vue_3.onUpdated)(() => {
            var _a;
            if (props.baseInfo) {
                if (props.model === 'base') {
                    const list = props.baseInfo;
                    showList.value = baseInfoList.value.map((data) => {
                        for (let i = 0; i < (list === null || list === void 0 ? void 0 : list.length); i++) {
                            if (list[i].label === (data === null || data === void 0 ? void 0 : data.name)) {
                                return {
                                    name: list[i].label,
                                    value: list[i].value === null ? '--' : list[i].value,
                                };
                            }
                        }
                        return {
                            name: data === null || data === void 0 ? void 0 : data.name,
                            value: '--',
                        };
                    });
                }
                else if (props.model === 'node') {
                    showList.value = (_a = props.baseInfo) === null || _a === void 0 ? void 0 : _a.map((item) => {
                        return {
                            name: item === null || item === void 0 ? void 0 : item.label,
                            value: (item === null || item === void 0 ? void 0 : item.value) === null ? '--' : item === null || item === void 0 ? void 0 : item.value,
                        };
                    });
                }
            }
            else {
                showList.value = [];
            }
        });
        return (_ctx, _cache) => {
            const _component_a_drawer = (0, vue_2.resolveComponent)("a-drawer");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_drawer, {
                open: __props.open,
                class: "custom-class",
                title: __props.title,
                placement: "right",
                onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:open', false)))
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(showList.value, (item) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, (0, vue_2.toDisplayString)(item.name) + "：" + (0, vue_2.toDisplayString)(item.value), 1));
                        }), 256))
                    ])
                ]),
                _: 1
            }, 8, ["open", "title"]));
        };
    }
});
